import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {bool, object, string} from 'prop-types';
import React, {useCallback} from 'react';
import {useController, useFormContext} from 'react-hook-form';

function Toggle({
  name,
  label,
  rules = {},
  defaultChecked = false,
  transform,
  ...props
}) {
  const {control} = useFormContext();
  const {field} = useController({
    name,
    control,
    rules,
    defaultValue: defaultChecked,
  });

  let required;
  if (typeof rules.required === 'object') {
    required = rules.required.value;
  } else {
    required = !!rules.required;
  }
  if ('required' in props && props.required !== required) {
    required = props.required;
    rules.required = required;
  }

  const value = transform?.input ? transform.input(field.value) : field.value;
  const onChange = useCallback(
    (...args) =>
      transform?.output
        ? field.onChange(transform.output(...args))
        : field.onChange(...args),
    [field, transform],
  );

  return (
    <FormControlLabel
      label={label}
      control={
        <Switch
          onChange={onChange}
          onBlur={field.onBlur}
          value={value}
          name={field.name}
          inputRef={field.ref}
          required={required}
          defaultChecked={defaultChecked}
          {...props}
        />
      }
    />
  );
}

Toggle.propTypes = {
  name: string.isRequired,
  label: string.isRequired,
  defaultChecked: bool,
  transform: object,
  defaultValue: string,
  rules: object,
  required: bool,
};

export default Toggle;
